(() => {
  const selector = '[data-cm-product-main][data-cm-product-mode="workshop"][data-cm-booking-css]';
  const sections = new WeakMap();
  const initialize = (section) => {
    if (sections.has(section)) return;
    const frames = new Map();
    const stylesheet = section.dataset.cmBookingCss;
    if (!stylesheet) return;
    const attach = (frame) => {
      if (frames.has(frame)) return;
      const apply = () => {
        let frameDocument;
        try { frameDocument = frame.contentDocument; } catch { return; }
        if (!frameDocument?.head || !frameDocument.querySelector('[data-react-component="ActivityWidgetContainer"]')) return;
        frameDocument.documentElement.dataset.cmBookingStyled = 'true';
        let link = frameDocument.querySelector('link[data-cm-booking-styles]');
        if (!link) {
          link = frameDocument.createElement('link');
          link.rel = 'stylesheet';
          link.dataset.cmBookingStyles = 'true';
          link.href = stylesheet;
          frameDocument.head.appendChild(link);
        }
        frame.dataset.cmBookingFrame = 'true';
      };
      frame.addEventListener('load', apply);
      frames.set(frame, apply);
      apply();
    };
    const scan = () => {
      section.querySelectorAll('iframe').forEach(attach);
      frames.forEach((apply, frame) => {
        if (!section.contains(frame)) {
          frame.removeEventListener('load', apply);
          frames.delete(frame);
        }
      });
    };
    const observer = new MutationObserver(scan);
    observer.observe(section, { childList: true, subtree: true });
    sections.set(section, () => {
      observer.disconnect();
      frames.forEach((apply, frame) => frame.removeEventListener('load', apply));
      frames.clear();
      sections.delete(section);
    });
    scan();
  };
  const scan = (scope) => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(selector)) sections.get(event.target)?.();
    event.target.querySelectorAll(selector).forEach((section) => sections.get(section)?.());
  });
})();
